import { DeviceDetectorService } from 'ngx-device-detector';
import { ReservationType } from './../tools/calendar/models/calendar.model';
import { ToastrService } from 'ngx-toastr';
import { ReservationService } from './../../services/reservation.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/services/guard/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from './../base/base.component';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { Event } from '../tools/calendar/models/calendar.model';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-availabilities',
  templateUrl: './availabilities.component.html',
  styleUrls: ['./availabilities.component.scss']
})
export class AvailabilitiesComponent extends BaseComponent implements OnInit {
  modalRef: BsModalRef;
  eventModel: Event;
  locale: string;

  events: Event[];
  ReservationType = ReservationType;
  reservationTypeKeys: string[] = [];

  constructor(
    translate: TranslateService,
    authService: AuthService,
    private modalService: BsModalService,
    private reservationService: ReservationService,
    private toast: ToastrService,
    private confirm: ConfirmationService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, authService, deviceDetectorService, route);
    this.reservationTypeKeys = Object.keys(ReservationType).filter(x => isNaN(parseInt(x, 10)));
    this.updateLocale();
    this.langChange.subscribe(lg => {
      this.updateLocale();
    });
  }

  updateLocale() {
    if (this.translate.currentLang === 'fr') {
      this.locale = 'fr-FR';
    } else {
      this.locale = 'en-US';
    }
  }

  ngOnInit(): void {
    this.getEvents();
  }

  getEvents() {
    this.reservationService.getReservations().subscribe(events => {
      this.events = events;
    });
  }

  newEvent(date: Date, template: TemplateRef<any>) {
    console.log('daySelect');
    const event = new Event();
    event.from = new Date(date);
    event.to = new Date(date);
    this.updateEvent(event, template);
  }

  updateEvent(event: Event, template: TemplateRef<any>) {
    console.log('eventSelect');
    if (!this.isAdmin) {
      return;
    }
    this.eventModel = Object.assign({}, event);
    this.modalRef = this.modalService.show(template);
  }

  saveEvent() {
    this.eventModel.from.setHours(8, 0, 0, 0);
    this.eventModel.to.setHours(8, 0, 0, 0);
    if (this.eventModel.id) {
      this.reservationService.updateReservation(this.eventModel).subscribe(
        () => {
          this.getEvents();
          this.toast.success('Event saved!');
        },
        err => this.toast.error('An error occured'),
        () => this.modalRef.hide()
      );
    } else {
      this.reservationService.addReservation(this.eventModel).subscribe(
        () => {
          this.getEvents();
          this.toast.success('Event saved!');
        },
        err => this.toast.error('An error occured'),
        () => this.modalRef.hide()
      );
    }
  }

  deleteEvent() {
    this.confirm.confirm({
      message: 'Are you Sure?',
      accept: () => {
        this.reservationService.deleteReservation(this.eventModel).subscribe(
          () => {
            this.getEvents();
            this.toast.success('Event deleted!');
          },
          err => this.toast.error('An error occured'),
          () => this.modalRef.hide()
        );
      }
    });
  }

  close() {
    this.modalRef.hide();
  }

}
